import { useDispatch } from "react-redux"
import { setCurrentLesson } from "../../../redux/lessonsSlice"
import { addTaskFiles, updateTask } from "../../../redux/taskSlice"
import toastWrapper from "../../../components/toastWrapper"


const useStudentLessonActionHandlers = (savedFiles, onResetSavedFiles) => {

    const dispatch = useDispatch()

    const handleSetCurrentLesson = lesson => { dispatch(setCurrentLesson(lesson)) }

    const handleSaveTask = data => {
        if (savedFiles?.[data.id]?.length > 0) {
            dispatch(addTaskFiles({
                id: data.id,
                files: savedFiles?.[data.id]?.map(el => el.id)
            })).unwrap()
                .then(() => { onResetSavedFiles(data.id) })
                .catch(e => {
                    console.error(e)
                    toastWrapper("Не удалось прикрепить файлы", "error")
                })
        }
        dispatch(updateTask({
            id: data.id,
            answer_text: data.answer_text,
        })).unwrap()
            .then(() => {
                toastWrapper("Ответ отправлен", "success")

            })
            .catch(e => {
                console.error(e)
                toastWrapper("Не удалось отправить ответ", "error")
            })

    }

    return { handleSetCurrentLesson, handleSaveTask }
}

export default useStudentLessonActionHandlers